var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1234 1.90723C8.09795 1.93715 4.82275 5.03123 4.82275 8.80335C4.82275 10.0591 5.19397 11.2946 5.88627 12.3616C7.72167 15.7778 11.9132 19.9829 11.9551 20.0255C11.9978 20.0682 12.0567 20.0924 12.1188 20.0933C12.1202 20.0933 12.1211 20.0933 12.1225 20.0933C12.1243 20.0933 12.1253 20.0933 12.1271 20.0933C12.1285 20.0933 12.1294 20.0933 12.1308 20.0933C12.1933 20.0924 12.2522 20.0678 12.2945 20.0255C12.3369 19.9829 16.5279 15.7778 18.355 12.3766C19.0561 11.2946 19.4273 10.0587 19.4273 8.80335C19.4278 5.03123 16.1526 1.93715 12.1234 1.90723ZM12.1253 11.1111C10.6569 11.1111 9.46691 9.97287 9.46691 8.56839C9.46691 7.16391 10.6569 6.02563 12.1253 6.02563C13.5936 6.02563 14.7836 7.16391 14.7836 8.56839C14.7836 9.97287 13.5936 11.1111 12.1253 11.1111Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMap);
export default __webpack_public_path__ + "static/media/icon-map.e8912c08.svg";
export { ForwardRef as ReactComponent };